import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// axios
import axios from "axios";
Vue.prototype.$axios = axios;

//copy
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

//i18n
import i18n from "./utils/i18n.js";

//vant
import Vant from "./utils/vant.js";
import { ImagePreview } from "vant";
import "vant/lib/index.css"; // 引入 Vant 样式文件
import "./styles/variables.scss"; // 引入自定义样式文件
import "./styles/fonts.scss"; // 引入字体样式文件
Vue.use(Vant);

// 添加 ImagePreview 全局方法
Vue.prototype.$imagePreview = ImagePreview;

//全局引入utils.js
import * as utils from "./utils/utils";
Vue.prototype.$utils = utils;

// 全局组件
import "./components/index.js";

Vue.config.productionTip = false;

import { fetchData, postData, request, uploadData } from "./api/api";
Vue.prototype.$api = {
	fetchData,
	postData,
	request,
	uploadData,
};

// 全局错误处理
window.addEventListener("error", (event) => {
	// 过滤掉浏览器扩展的错误
	if (event.filename && event.filename.includes("content_script.js")) {
		event.preventDefault();
		console.log("浏览器扩展错误已过滤：", event.message);
		return;
	}
	// 其他错误正常处理
	console.error("应用错误：", event.error);
});

if (process.env.NODE_ENV === "production") {
	window.addEventListener("unhandledrejection", (event) => {
		event.preventDefault(); // 阻止生产环境弹窗
		console.log("错误捕获：", event.reason);
	});
}

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount("#app");
